
import { SearchCriteria } from "./search-criteria";

export class ChangeGymMembershipClientModel extends SearchCriteria {

  public GymClientMembershipId: number;
  public NewClientId: number;
}

